const setProviderDefaults = function (state, data) {
  const { conversationChannel } = data
  state.providerDefaults = {}
  state.providerDefaults = conversationChannel?.defaults ?? null
}

export default setProviderDefaults
